import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "creating-a-plugin-with-the-uxp-developer-tool"
    }}>{`Creating a Plugin with the UXP Developer Tool`}</h1>
    <p>{`So you have Photoshop, you have the UXP Developer Tool, and you have Visual Studio Code or other programmer's text editor. Now what?`}</p>
    <p>{`First make sure you have the UXP Developer Tool (UDT). You can download installers for the UDT `}<a parentName="p" {...{
        "href": "/photoshop/uxp/2021/devtool/"
      }}>{`here`}</a>{`. Once it's downloaded, run the installer just like any other on Mac or Windows. On macOS, it creates a folder in your `}<inlineCode parentName="p">{`Applications`}</inlineCode>{` folder named "Adobe UXP Developer Tools." On Windows, the folder is on the boot drive in the `}<inlineCode parentName="p">{`Program Files->Adobe`}</inlineCode>{` folder. Then follow these steps:`}</p>
    <ol>
      <li parentName="ol">{`Launch Photoshop.`}</li>
      <li parentName="ol">{`Launch the UXP Developer Tool. If you've never launched it before, you should see a window like this:`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "895px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "61.24999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/588b26ce22af87ab9839116b42a19976/5530d/udt-start.webp 320w", "/photoshop/uxp/2021/static/588b26ce22af87ab9839116b42a19976/0c8fb/udt-start.webp 640w", "/photoshop/uxp/2021/static/588b26ce22af87ab9839116b42a19976/dd3ab/udt-start.webp 895w"],
            "sizes": "(max-width: 895px) 100vw, 895px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/588b26ce22af87ab9839116b42a19976/dd4a7/udt-start.png 320w", "/photoshop/uxp/2021/static/588b26ce22af87ab9839116b42a19976/0f09e/udt-start.png 640w", "/photoshop/uxp/2021/static/588b26ce22af87ab9839116b42a19976/b002d/udt-start.png 895w"],
            "sizes": "(max-width: 895px) 100vw, 895px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/588b26ce22af87ab9839116b42a19976/b002d/udt-start.png",
            "alt": "UDT Start",
            "title": "UDT Start",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`You'll also see this window if you have no plugins loaded in the Tool.`}</p>
    <p>{`The left pane shows applications that are "connected" to the tool. At this time, the only applications that can connect are Photoshop and XD. In this pane, you should see "Adobe Photoshop" in the `}<inlineCode parentName="p">{`Connected Applications`}</inlineCode>{` list. If you don't, something is wrong; UDT can't connect to Photoshop. Make sure you're running at least version 22.0.0 of Photoshop; earlier versions did not support UXP.`}</p>
    <p>{`The center pane shows the plugs that are loaded in UDT, but you don't have any yet. At the top right is a gear icon; if selected, it shows this sheet:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "581px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "74.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/ed6f8bc4734dc6ebbf5c377c36001c08/5530d/udt-gear-icon.webp 320w", "/photoshop/uxp/2021/static/ed6f8bc4734dc6ebbf5c377c36001c08/cf388/udt-gear-icon.webp 581w"],
            "sizes": "(max-width: 581px) 100vw, 581px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/ed6f8bc4734dc6ebbf5c377c36001c08/dd4a7/udt-gear-icon.png 320w", "/photoshop/uxp/2021/static/ed6f8bc4734dc6ebbf5c377c36001c08/3f4f8/udt-gear-icon.png 581w"],
            "sizes": "(max-width: 581px) 100vw, 581px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/ed6f8bc4734dc6ebbf5c377c36001c08/3f4f8/udt-gear-icon.png",
            "alt": "UDT gear icon sheet",
            "title": "UDT gear icon sheet",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`You shouldn't need to change the Service Port, which is what UDT uses to communicate with host applications. Feel free to change the theme.`}</p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Close that sheet, then click `}<inlineCode parentName="li">{`Create Plugin`}</inlineCode>{`. You'll see this dialog:`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "945px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "77.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/5f8dadba6df767d7c792d2c9fdc61cdc/5530d/create-plugin.webp 320w", "/photoshop/uxp/2021/static/5f8dadba6df767d7c792d2c9fdc61cdc/0c8fb/create-plugin.webp 640w", "/photoshop/uxp/2021/static/5f8dadba6df767d7c792d2c9fdc61cdc/7bcb4/create-plugin.webp 945w"],
            "sizes": "(max-width: 945px) 100vw, 945px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/5f8dadba6df767d7c792d2c9fdc61cdc/dd4a7/create-plugin.png 320w", "/photoshop/uxp/2021/static/5f8dadba6df767d7c792d2c9fdc61cdc/0f09e/create-plugin.png 640w", "/photoshop/uxp/2021/static/5f8dadba6df767d7c792d2c9fdc61cdc/e7d8e/create-plugin.png 945w"],
            "sizes": "(max-width: 945px) 100vw, 945px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/5f8dadba6df767d7c792d2c9fdc61cdc/e7d8e/create-plugin.png",
            "alt": "Create Plugin dialog",
            "title": "Create Plugin dialog",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Fill in the fields. The text in gray is cue text, `}<em parentName="li">{`not`}</em>{` a default value, so you need to fill in `}<em parentName="li">{`all`}</em>{` the fields. Give your plugin a unique name (i.e. don't call it "Layers") and plugin ID. Select "Adobe Photoshop" as the Host Application. Select "ps-starter" as the Template.`}</li>
    </ol>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p><strong parentName="p">{`IMPORTANT`}</strong>{`:
When you distribute your plugin, you'll need to obtain a plugin ID from the `}<a parentName="p" {...{
        "href": "https://console.adobe.io/home"
      }}>{`Adobe Developer Console`}</a>{`. For testing, though, just invent an id like 'com.yourname.pluginname'.`}</p>
    <p>{`For this exercise, we'll use the `}<inlineCode parentName="p">{`ps-starter`}</inlineCode>{` template, which creates a very basic plugin using basic JavaScript with no libraries. Other choices in the `}<inlineCode parentName="p">{`Template`}</inlineCode>{` popup include `}<inlineCode parentName="p">{`ps-react-starter`}</inlineCode>{`, which creates a simple React-based plugin.`}</p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Next`}</inlineCode>{`. UDT will prompt for a location in which to save the plugin files. Note that it `}<em parentName="li">{`does not`}</em>{` create a folder by default, so save your plugin into a previously-created empty folder, or click the `}<inlineCode parentName="li">{`create folder`}</inlineCode>{` icon in the top left of the Save dialog:`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1026px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "9.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/7d284b9d6794248e610ab1a0917a9ec5/5530d/create-folder.webp 320w", "/photoshop/uxp/2021/static/7d284b9d6794248e610ab1a0917a9ec5/0c8fb/create-folder.webp 640w", "/photoshop/uxp/2021/static/7d284b9d6794248e610ab1a0917a9ec5/a9696/create-folder.webp 1026w"],
            "sizes": "(max-width: 1026px) 100vw, 1026px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/7d284b9d6794248e610ab1a0917a9ec5/dd4a7/create-folder.png 320w", "/photoshop/uxp/2021/static/7d284b9d6794248e610ab1a0917a9ec5/0f09e/create-folder.png 640w", "/photoshop/uxp/2021/static/7d284b9d6794248e610ab1a0917a9ec5/9cda9/create-folder.png 1026w"],
            "sizes": "(max-width: 1026px) 100vw, 1026px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/7d284b9d6794248e610ab1a0917a9ec5/9cda9/create-folder.png",
            "alt": "Create Folder",
            "title": "Create Folder",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`The Developer Tool will save your plugin files, and you should then see this message:`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1190px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.874999999999996%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/687ab2906c6129f4f96b1ce4672a906a/5530d/success.webp 320w", "/photoshop/uxp/2021/static/687ab2906c6129f4f96b1ce4672a906a/0c8fb/success.webp 640w", "/photoshop/uxp/2021/static/687ab2906c6129f4f96b1ce4672a906a/c89d2/success.webp 1190w"],
            "sizes": "(max-width: 1190px) 100vw, 1190px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/687ab2906c6129f4f96b1ce4672a906a/dd4a7/success.png 320w", "/photoshop/uxp/2021/static/687ab2906c6129f4f96b1ce4672a906a/0f09e/success.png 640w", "/photoshop/uxp/2021/static/687ab2906c6129f4f96b1ce4672a906a/ba099/success.png 1190w"],
            "sizes": "(max-width: 1190px) 100vw, 1190px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/687ab2906c6129f4f96b1ce4672a906a/ba099/success.png",
            "alt": "Plugin Created",
            "title": "Plugin Created",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <blockquote>
      <p parentName="blockquote">{`The message says you need run extra commands from the terminal. This is not true for simple JavaScript-only plugins, only for React-based ones.`}</p>
    </blockquote>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Now, load your new plugin by clicking the `}<inlineCode parentName="li">{`•••`}</inlineCode>{` (aka "Actions") menu (next to the name of the plugin you just created), and select `}<inlineCode parentName="li">{`Load`}</inlineCode>{`.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/5530d/load-plugin.webp 320w", "/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/0c8fb/load-plugin.webp 640w", "/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/94b1e/load-plugin.webp 1280w", "/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/6665b/load-plugin.webp 1544w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/dd4a7/load-plugin.png 320w", "/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/0f09e/load-plugin.png 640w", "/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/bbbf7/load-plugin.png 1280w", "/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/bb3e3/load-plugin.png 1544w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/1e9248d8a79ea47becf38f39d770c133/bbbf7/load-plugin.png",
            "alt": "Load Plugin",
            "title": "Load Plugin",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{` You should see a message like this at the bottom of the UDT window:`}</p>
    <p>{` `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "337px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "20%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/5cdfa43b4222041173046eb76951756e/5530d/udt-load-successful.webp 320w", "/photoshop/uxp/2021/static/5cdfa43b4222041173046eb76951756e/413c5/udt-load-successful.webp 337w"],
            "sizes": "(max-width: 337px) 100vw, 337px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/5cdfa43b4222041173046eb76951756e/dd4a7/udt-load-successful.png 320w", "/photoshop/uxp/2021/static/5cdfa43b4222041173046eb76951756e/f57f1/udt-load-successful.png 337w"],
            "sizes": "(max-width: 337px) 100vw, 337px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/5cdfa43b4222041173046eb76951756e/f57f1/udt-load-successful.png",
            "alt": "Load Successful",
            "title": "Load Successful",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{` Now take a look at Photoshop; your new plugin panel should be running!`}</p>
    <p>{` If it didn't load, you'll see an error popup like this:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "400px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "15.937499999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/ea0c8dfa3f29b1a483b3432963dd7072/5530d/udt-load-failed.webp 320w", "/photoshop/uxp/2021/static/ea0c8dfa3f29b1a483b3432963dd7072/2276a/udt-load-failed.webp 400w"],
            "sizes": "(max-width: 400px) 100vw, 400px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/ea0c8dfa3f29b1a483b3432963dd7072/dd4a7/udt-load-failed.png 320w", "/photoshop/uxp/2021/static/ea0c8dfa3f29b1a483b3432963dd7072/d9f49/udt-load-failed.png 400w"],
            "sizes": "(max-width: 400px) 100vw, 400px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/ea0c8dfa3f29b1a483b3432963dd7072/d9f49/udt-load-failed.png",
            "alt": "Load Failed",
            "title": "Load Failed",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{` Clicking the `}<inlineCode parentName="p">{`Details`}</inlineCode>{` link in this message will show an error log indicating why the plugin failed to load:`}</p>
    <p>{` `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1270px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/3788e7c67c2eaaa4fe1a21218966f4a6/5530d/udt-failure-log.webp 320w", "/photoshop/uxp/2021/static/3788e7c67c2eaaa4fe1a21218966f4a6/0c8fb/udt-failure-log.webp 640w", "/photoshop/uxp/2021/static/3788e7c67c2eaaa4fe1a21218966f4a6/ad398/udt-failure-log.webp 1270w"],
            "sizes": "(max-width: 1270px) 100vw, 1270px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/3788e7c67c2eaaa4fe1a21218966f4a6/dd4a7/udt-failure-log.png 320w", "/photoshop/uxp/2021/static/3788e7c67c2eaaa4fe1a21218966f4a6/0f09e/udt-failure-log.png 640w", "/photoshop/uxp/2021/static/3788e7c67c2eaaa4fe1a21218966f4a6/6b882/udt-failure-log.png 1270w"],
            "sizes": "(max-width: 1270px) 100vw, 1270px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/3788e7c67c2eaaa4fe1a21218966f4a6/6b882/udt-failure-log.png",
            "alt": "Failure Log",
            "title": "Failure Log",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "now-what"
    }}>{`Now What?`}</h2>
    <p>{` Customize your plugin by editing the .js and .html files, perhaps adding some CSS. Make it your own! Don't forget to edit the `}<inlineCode parentName="p">{`README.md`}</inlineCode>{` file and, if necessary, the `}<inlineCode parentName="p">{`manifest.json`}</inlineCode>{` file.`}</p>
    <p>{`In case you've closed your plugin's panel in Photoshop, you can find it again in Photoshop's `}<inlineCode parentName="p">{`Plugin`}</inlineCode>{` menu:`}</p>
    <p>{` `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "613px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/5e156b5ddcee415a755d8ae104653621/5530d/udt-ps-plugins-menu.webp 320w", "/photoshop/uxp/2021/static/5e156b5ddcee415a755d8ae104653621/5c2f3/udt-ps-plugins-menu.webp 613w"],
            "sizes": "(max-width: 613px) 100vw, 613px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/5e156b5ddcee415a755d8ae104653621/dd4a7/udt-ps-plugins-menu.png 320w", "/photoshop/uxp/2021/static/5e156b5ddcee415a755d8ae104653621/ac863/udt-ps-plugins-menu.png 613w"],
            "sizes": "(max-width: 613px) 100vw, 613px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/5e156b5ddcee415a755d8ae104653621/ac863/udt-ps-plugins-menu.png",
            "alt": "Plugins Menu",
            "title": "Plugins Menu",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "watching-reloading-and-debugging"
    }}>{`Watching, Reloading, and Debugging`}</h2>
    <p>{` Selecting the `}<inlineCode parentName="p">{`Watch`}</inlineCode>{` item from the Actions menu causes the Developer Tool to watch for any changes in your code on disk.
Whenever you make a change to a file in your project, UDT will reload your plugin automatically. This makes for a very rapid code->make mistakes->fix mistakes->reload cycle.`}</p>
    <p>{` You can also reload your plugin manually by selecting `}<inlineCode parentName="p">{`Reload`}</inlineCode>{` from the Actions menu. If you have `}<inlineCode parentName="p">{`Watch`}</inlineCode>{` enabled, you shouldn't have to do this. But some people are superstitious.`}</p>
    <p>{` You can also debug your plugin by choosing `}<inlineCode parentName="p">{`Debug`}</inlineCode>{` from the Actions menu. This brings up a window like this:`}</p>
    <p>{` `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1138px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.62500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/145d380615f132327c64db1c817400e8/5530d/udt-debugger.webp 320w", "/photoshop/uxp/2021/static/145d380615f132327c64db1c817400e8/0c8fb/udt-debugger.webp 640w", "/photoshop/uxp/2021/static/145d380615f132327c64db1c817400e8/58ffc/udt-debugger.webp 1138w"],
            "sizes": "(max-width: 1138px) 100vw, 1138px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2021/static/145d380615f132327c64db1c817400e8/dd4a7/udt-debugger.png 320w", "/photoshop/uxp/2021/static/145d380615f132327c64db1c817400e8/0f09e/udt-debugger.png 640w", "/photoshop/uxp/2021/static/145d380615f132327c64db1c817400e8/0ff2a/udt-debugger.png 1138w"],
            "sizes": "(max-width: 1138px) 100vw, 1138px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2021/static/145d380615f132327c64db1c817400e8/0ff2a/udt-debugger.png",
            "alt": "Debug Window",
            "title": "Debug Window",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{` In this debugger (which resembles the Chrome debugger) you can look at the console log, and do the usual debugger things such as setting breakpoints, stepping into and out of functions, etc. If you just want to look at logs without dealing with the debugger, you can choose the `}<inlineCode parentName="p">{`Logs`}</inlineCode>{` option in the Actions menu.`}</p>
    <h2 {...{
      "id": "multiple-plugins"
    }}>{`Multiple Plugins`}</h2>
    <p>{` You can host as many plugins as you want in the UXP Developer Tool. You can either create the plugin folder structure and files from scratch and click the blue `}<inlineCode parentName="p">{`Add Plugin`}</inlineCode>{` button in the Tool, or you can click the `}<inlineCode parentName="p">{`Create Plugin`}</inlineCode>{` button to have it created for you, wizard-style. Then you choose the `}<inlineCode parentName="p">{`Load`}</inlineCode>{` item in the Actions menu to load your plugin into Photoshop.`}</p>
    <h2 {...{
      "id": "packaging"
    }}>{`Packaging`}</h2>
    <p>{` In order to distribute your plugin (after it's been throughly polished and debugged), you'll need to package it as a "ccx" file. This is easily accomplished by choosing the `}<inlineCode parentName="p">{`Package`}</inlineCode>{` option in the Actions menu. Make sure you get a plugin ID from the `}<a parentName="p" {...{
        "href": "https://console.adobe.io/home"
      }}>{`Adobe Developer Console`}</a>{` website before packaging your plugin for distribution.`}</p>
    <p>{` To distribute your plugin, see `}<a parentName="p" {...{
        "href": "/photoshop/uxp/2021/distribution/"
      }}>{`Sharing Your Plugin`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      